import { render, staticRenderFns } from "./click-to-copy-text.vue?vue&type=template&id=287dd2c3&scoped=true"
import script from "./click-to-copy-text.vue?vue&type=script&lang=js"
export * from "./click-to-copy-text.vue?vue&type=script&lang=js"
import style0 from "./click-to-copy-text.vue?vue&type=style&index=0&id=287dd2c3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "287dd2c3",
  null
  
)

export default component.exports